import { MOTION_DURATION, MOTION_EASING, MOTION_TRANSITIONS } from '../../designsystem/tokens';

export function MotionTokenPreview() {
  const durations = Object.entries(MOTION_DURATION) as [string, number][];
  const easings = Object.entries(MOTION_EASING) as [string, string][];
  const maxMs = MOTION_DURATION.slower;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-300">Duration Tokens</h3>
        <div className="mt-3 space-y-2">
          {durations.map(([name, ms]) => (
            <div key={name} className="flex items-center gap-3">
              <span className="w-16 font-mono text-xs capitalize text-slate-500">{name}</span>
              <span className="w-12 font-mono text-xs text-slate-400">{ms}ms</span>
              <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                <div
                  className="h-full rounded-full bg-brand-500"
                  style={{ width: ms === 0 ? '100%' : `${Math.max((ms / maxMs) * 100, 8)}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-300">Easing Curves</h3>
        <dl className="mt-2 space-y-1 text-sm">
          {easings.map(([name, value]) => (
            <div key={name} className="flex justify-between">
              <dt className="capitalize text-slate-600 dark:text-slate-400">{name}</dt>
              <dd className="font-mono text-xs text-slate-500">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
      <div>
        <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-300">Transition Presets</h3>
        <dl className="mt-2 space-y-1 text-sm">
          {Object.entries(MOTION_TRANSITIONS).map(([name, value]) => (
            <div key={name}>
              <dt className="capitalize text-slate-600 dark:text-slate-400">{name}</dt>
              <dd className="font-mono text-xs text-slate-500">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
